/**
 * PublishStateNote — a small, consistent callout that tells the committee user
 * whether edits on the current page are LIVE immediately or staged behind a
 * draft→publish step (ra-3mof).
 *
 * Committee edit surfaces fall into two persistence models:
 *   - 'instant'  — the page writes straight to the live club data that the app /
 *                  public reads; there is no publish step. Users see the change
 *                  the next time the app loads the club's data.
 *   - 'draft'    — the page stages edits into a work-in-progress bundle; nothing
 *                  reaches app users until the bundle is Published (Course Cards →
 *                  Create Bundle) and then Activated (Version History).
 *
 * The two models are otherwise indistinguishable in the UI, which is exactly the
 * confusion this note removes. Copy stays deliberately short; pass `children` to
 * add surface-specific detail (e.g. where the publish button lives).
 */
export default function PublishStateNote({ mode, children }) {
  const isInstant = mode === 'instant';
  return (
    <div className={`publish-state-note ${isInstant ? 'is-instant' : 'is-draft'}`} role="note">
      <span className="publish-state-badge">
        {isInstant ? 'Live now' : 'Draft'}
      </span>
      <div className="publish-state-body">
        {isInstant ? (
          <p>
            Changes here save <strong>straight to the live club data</strong> — no
            publish step. Users see them the next time the app loads this club.
          </p>
        ) : (
          <p>
            Changes here are saved to a <strong>draft</strong> and are not visible
            to users yet. To go live: <strong>Course Cards → Create Bundle</strong>,
            then <strong>Version History → Activate</strong>.
          </p>
        )}
        {children}
      </div>
    </div>
  );
}
